export const useUnidadeMedica = () => {
  const api = useApi();

  function obtemUnidadesAtivas(){
    return api.get<RespostaObterTodosUnidade>("/unidade-medica/ativas");
  }
  
  function obterTodos(){
    return api.get<{ object: Array<UnidadeMedica> }>("/unidade-medica/todas");
  }
  
  function obterTodosPaginacaoOrdenacao(pagina: number, search: string, column: stirng, order: string){
    return api.get<{ object: Array<UnidadeMedica> }>(`/unidade-medica/ordenacao/${pagina}/${search}/${column}/${order}`);
  }

  function obterUm(id: number){
    return api.get<{ object: UnidadeMedica }>(`/unidade-medica/${id}`);
  }

  function cadastro(unidade: UnidadeMedica){
    return api.post<{ object: UnidadeMedica }>("/unidade-medica", unidade);
  }

  function alteracao(unidade: UnidadeMedica){
    return api.put<{ object: UnidadeMedica }>(`/unidade-medica/${unidade.id}`, unidade);
  }

  function exclusao(id: number){
    return api.delete<{ object: UnidadeMedica }>(`/unidade-medica/${id}`);
  }

  return { obtemUnidadesAtivas, obterTodosPaginacaoOrdenacao, obterTodos, obterUm, cadastro, alteracao, exclusao };
};